import React, { useEffect, useState } from "react";
import { Clapperboard } from "lucide-react";
import Slideshow from "./Slideshow";
import api from "../lib/api";
import { lessonDayStatus } from "../lib/lessonDay";

// Lesson-day reward: once the child has done a step today, offer a full-screen slideshow of the photos grandparents sent them.
const LessonDayShow = ({ child }) => {
  const [photos, setPhotos] = useState([]);
  const [open, setOpen] = useState(false);
  const ld = lessonDayStatus(child?.lessonDay, child?.activity || []);
  const eligible = !!child?.ownerId && !child.readOnly && !!ld?.isToday && ld.doneToday;

  useEffect(() => {
    if (!eligible) return;
    api.get("/family/photos").then((r) => setPhotos(r.data.photos.filter((p) => p.child_id === child.id))).catch(() => setPhotos([]));
  }, [eligible, child?.id]);

  if (!eligible || !photos.length) return null;
  return (
    <>
      <div className="mt-6 bg-[#1b8bc9] text-white rounded-3xl p-5 flex flex-col sm:flex-row items-center gap-4 bubble-in" data-testid="lesson-day-show">
        <span className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center flex-shrink-0"><Clapperboard /></span>
        <div className="flex-1 text-center sm:text-left">
          <p className="font-bold text-lg" style={{ fontFamily: "Literata, serif" }}>Lesson day treat for {child.panda.name}!</p>
          <p className="text-sm text-white/90">You did a lesson step today - here are {photos.length} photo{photos.length === 1 ? "" : "s"} your family sent you.</p>
        </div>
        <button type="button" onClick={() => setOpen(true)} className="btn-pill bg-[#e5356f] hover:bg-[#c92a5e] text-white shadow inline-flex items-center gap-2" data-testid="lesson-day-show-button"><Clapperboard size={18} /> Watch your photo show</button>
      </div>
      {open && <Slideshow photos={photos} onClose={() => setOpen(false)} />}
    </>
  );
};

export default LessonDayShow;
